export default __webpack_public_path__ + "static/media/uknown.35b28ce6.svg";